import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const filterDataClassName = DataClassName.FILTER
const filterEndpoint = PisaDataClassEndpoint.FILTER

export function pisaFilterDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(filterDataClassName, {
    title: filterDataClassName,
    restApi: createPisaRestApiConfig(filterEndpoint),
    attributes,
  })
}
